import { HeadingProps, Heading as PomodoroHeading } from '@ifood/pomodoro-components';

export const Heading: React.FC<HeadingProps> = ({ children, ...headingProps }) => {
  return (
    <PomodoroHeading color="headings" {...headingProps}>
      {children}
    </PomodoroHeading>
  );
};
